import { HttpClient } from "@microsoft/signalr";
import { NetworkLayer } from "../../sdk/index";
import { HttpClientImpl } from "./client.impl";
import { host} from '../../network/host'
let httpclient = new HttpClientImpl(host)
let networkLayer =  new NetworkLayer(httpclient)
export {networkLayer}
